/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upcoming_TitleInputs */

const id_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul`)
};

const ms_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk`)
};

const da_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const de_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const en_us2_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const es_es2_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const es_mx2_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const fil_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamagat`)
};

const fr_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

const it_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo`)
};

const hu_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cím`)
};

const nl_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const no_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittel`)
};

const pl_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł`)
};

const pt_br2_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const pt_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const ro_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlu`)
};

const fi_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikko`)
};

const sv_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const vi_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề`)
};

const tr_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık`)
};

const cs_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const bg_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавие`)
};

const ru_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название`)
};

const uk_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва`)
};

const ar_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان`)
};

const hi_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक`)
};

const th_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const ja_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

const zh_cn2_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const zh_hant1_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const ko_components_upcoming_title = /** @type {(inputs: Components_Upcoming_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Components_Upcoming_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_upcoming_title = /** @type {((inputs?: Components_Upcoming_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upcoming_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_upcoming_title(inputs)
	if (locale === "ms") return ms_components_upcoming_title(inputs)
	if (locale === "da") return da_components_upcoming_title(inputs)
	if (locale === "de") return de_components_upcoming_title(inputs)
	if (locale === "en-US") return en_us2_components_upcoming_title(inputs)
	if (locale === "es-ES") return es_es2_components_upcoming_title(inputs)
	if (locale === "es-MX") return es_mx2_components_upcoming_title(inputs)
	if (locale === "fil") return fil_components_upcoming_title(inputs)
	if (locale === "fr") return fr_components_upcoming_title(inputs)
	if (locale === "it") return it_components_upcoming_title(inputs)
	if (locale === "hu") return hu_components_upcoming_title(inputs)
	if (locale === "nl") return nl_components_upcoming_title(inputs)
	if (locale === "no") return no_components_upcoming_title(inputs)
	if (locale === "pl") return pl_components_upcoming_title(inputs)
	if (locale === "pt-BR") return pt_br2_components_upcoming_title(inputs)
	if (locale === "pt") return pt_components_upcoming_title(inputs)
	if (locale === "ro") return ro_components_upcoming_title(inputs)
	if (locale === "fi") return fi_components_upcoming_title(inputs)
	if (locale === "sv") return sv_components_upcoming_title(inputs)
	if (locale === "vi") return vi_components_upcoming_title(inputs)
	if (locale === "tr") return tr_components_upcoming_title(inputs)
	if (locale === "cs") return cs_components_upcoming_title(inputs)
	if (locale === "bg") return bg_components_upcoming_title(inputs)
	if (locale === "ru") return ru_components_upcoming_title(inputs)
	if (locale === "uk") return uk_components_upcoming_title(inputs)
	if (locale === "ar") return ar_components_upcoming_title(inputs)
	if (locale === "hi") return hi_components_upcoming_title(inputs)
	if (locale === "th") return th_components_upcoming_title(inputs)
	if (locale === "ja") return ja_components_upcoming_title(inputs)
	if (locale === "zh-CN") return zh_cn2_components_upcoming_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_upcoming_title(inputs)
	return ko_components_upcoming_title(inputs)
});
export { components_upcoming_title as "components.upcoming.title" }